jQuery(document).ready(function($){
  if( $('input.phone-field').length ) {
    $('input.phone-field').each(function(){
      $(this).attr('maxlength', '24');
    });

    if($('input.phone-field').length) {
      $('input.phone-field').inputmask({"mask": "(999) 999-9999"});
    }
    
    /*
    $(document).on('keypress', 'input.phone-field', function(e) {
        var charCode = (e.which) ? e.which : e.keyCode;
        if (charCode !== 43 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
        }
    }).on('keyup', 'input.phone-field', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    }).on('paste', 'input.phone-field', function(e) {
        e.preventDefault();
      
        var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
        var pastedText = clipboardData.getData('text');
        var filteredText = pastedText.replace(/[^0-9\+]/g, '');

        var input = this;
        var start = input.selectionStart;
        var end = input.selectionEnd;
        var currentText = $(input).val();

        $(input).val(
            currentText.substring(0, start) +
            filteredText +
            currentText.substring(end)
        );

        input.selectionStart = input.selectionEnd = start + filteredText.length;
    });*/
  }
  
  // $(document).scroll();
});

jQuery(document).on('scroll', function() {
  let scroll = jQuery(document).scrollTop();

  /*if( jQuery('header.main-header .main-navigation-wrapper').length ) {
    let $header = jQuery('header.main-header');
    let $menu = $header.find('.main-navigation-wrapper');
    let $header_wrapper = $header.find('.header-wrapper');

    if ( $(window).width() > 720 ) {
      $header.css('margin-bottom', $menu.innerHeight() + 'px');
      
      if( scroll > $header_wrapper.offset().top + $header_wrapper.innerHeight() ) {
        $menu.addClass('fixed');
      } else if( $menu.hasClass('fixed') ) {
        $menu.removeClass('fixed');
      }
    } else {
      if( $menu.hasClass('fixed') ) {
        $menu.removeClass('fixed');
        $header.css('margin-bottom', '0');
      }
    }
  }*/
});